<template>
  <b-modal
    :id="`order-create-wallet-modal-${orderId}`"
    :modal-class="'default-modal'"
    header-class="justify-content-between"
    :hide-footer="true"
    @shown="shown"
    @hidden="hidden"
  >

    <template #modal-header="{ close }">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>Creditar valor</span>
        </h2>
      </div>
      <!--begin::Close-->
      <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="close()">
          <span class="svg-icon svg-icon-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
            </svg>
          </span>
      </div>
      <!--end::Close-->
    </template>

    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="mt-4 text-center">
      <template v-if="loader && !order">
        <div class="text-center">
          <Loader
            :size="'big'"
          />
        </div>
      </template>
      <template v-else-if="order">
        <p>Você tem certeza que deseja creditar <strong>{{ order.amount/ 100 | formatMoney }}</strong> para o anunciante <strong>{{ order.advertiser.name }}</strong>?</p>
        <Button
          type="button"
          class="btn btn-primary mt-4"
          @click="submit"
          :loading="loader"
        >
          Creditar valor
        </Button>
      </template>
    </div>
  </b-modal>
</template>
<script>

import NotificationsService from '@/modules/notifications/services/notifications-service'
import OrdersService from '@/modules/orders/services/orders-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'OrderCreateWalletModal',
  props: ['orderId'],
  components: {
    AlertWraper,
    Button,
    Loader
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false,
      order: null
    }
  },
  methods: {
    /**
     * Get order
     */
    async getOrder () {
      this.loader = true
      try {
        this.order = await OrdersService.getOrder(this.orderId)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * On hidden
     */
    hidden () {
      this.order = null
      this.content = null
    },
    /**
     * On shown
     */
    shown () {
      this.getOrder()
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        const wallet = await OrdersService.createWallet(this.orderId)
        this.$bvModal.hide(`order-create-wallet-modal-${this.orderId}`)
        this.$emit('created', wallet)
        NotificationsService.createGlobalSuccessQuickNotification('Valor creditado com sucesso')
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
